<template>
  <rp-permissions :requireOne="['read_surgeons']">
    <div v-if="show" class="sidebar-links">
        <router-link to="/surgeons" :class="{active: isAllSurgeons}">All surgeons</router-link>
    </div>
  </rp-permissions>
</template>

<script>
import Permissions from 'raypro_ui/src/components/Permissions'

export default {
  components: {'rp-permissions': Permissions},
  computed: {
    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('/patients').test(this.path) ||
        new RegExp('/operations').test(this.path) ||
        new RegExp('/surgeons').test(this.path) ||
        new RegExp('/users').test(this.path)
    },

    isAllSurgeons() {
      return new RegExp('/surgeons').test(this.path)
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/SurgeonsLinks.vue